import { buildLegacyEffectEntries } from './effectModel';

const LEGACY_STAT_RX = /^\s*([+-])\s*(\d+)\s*(str|strength|dex|dexterity|con|constitution|int|intelligence|wis|wisdom|cha|charisma)\s*$/i;

const STAT_ALIASES = {
  str: new Set(['str', 'strength']),
  dex: new Set(['dex', 'dexterity']),
  con: new Set(['con', 'constitution']),
  int: new Set(['int', 'intelligence']),
  wis: new Set(['wis', 'wisdom']),
  cha: new Set(['cha', 'charisma']),
};

const toArray = (value) => (Array.isArray(value) ? value : []);

const buildLegacyStateFromChar = (char = {}) => ({
  buffList: char.buffList,
  debuffList: char.debuffList,
  permBuffs: char.permanentBuffs,
  permDebuffs: char.permanentDebuffs,
  buffData: char.buffData,
  buffSources: char.buffSources,
  buffNotes: char.buffNotes,
  disabledBuffs: char.disabledBuffs,
  disabledDebuffs: char.disabledDebuffs,
  hiddenBuffs: char.hiddenBuffs,
  hiddenDebuffs: char.hiddenDebuffs,
});

const getActiveLegacyEntries = ({ char = null, legacyState = null } = {}) => {
  const state = legacyState || (char ? buildLegacyStateFromChar(char) : null);
  if (!state) return [];
  return buildLegacyEffectEntries(state).filter((effect) => !effect.isDisabled);
};

const effectMatchesFilters = (effect, {
  categories = ['buff', 'debuff'],
  includePermanent = true,
  includeTemporary = true,
} = {}) => {
  if (!toArray(categories).includes(effect.category)) return false;
  if (effect.permanence === 'permanent') return includePermanent;
  if (effect.permanence === 'temporary') return includeTemporary;
  return false;
};

const normalizeStat = (stat) => String(stat || '').trim().toLowerCase();

export const getActiveLegacyEffectNames = ({
  char = null,
  legacyState = null,
  categories = ['buff', 'debuff'],
  includePermanent = true,
  includeTemporary = true,
} = {}) => (
  getActiveLegacyEntries({ char, legacyState })
    .filter((effect) => effectMatchesFilters(effect, {
      categories,
      includePermanent,
      includeTemporary,
    }))
    .map((effect) => effect.text)
);

export const getActiveLegacyStatDelta = ({
  char = null,
  legacyState = null,
  stat = '',
  categories = ['buff', 'debuff'],
  includePermanent = true,
  includeTemporary = true,
} = {}) => {
  const statKey = normalizeStat(stat);
  const validAliases = STAT_ALIASES[statKey];
  if (!validAliases) return 0;

  return getActiveLegacyEntries({ char, legacyState })
    .filter((effect) => effectMatchesFilters(effect, {
      categories,
      includePermanent,
      includeTemporary,
    }))
    .reduce((sum, effect) => {
      const match = String(effect.text || '').match(LEGACY_STAT_RX);
      if (!match) return sum;
      if (!validAliases.has(match[3].toLowerCase())) return sum;
      const value = parseInt(match[2], 10);
      return sum + (match[1] === '+' ? value : -value);
    }, 0);
};
